// =============================================================================
// Pintravel — /trips/:tripId/map → /map?trip=:tripId
// =============================================================================
// There is one map now, scoped by a query param. The old per-trip route keeps
// working — every "Map" button inside a trip still points at it — but lands on
// the Map tab, which is where people look for a trip's map in the first place.
//
// Its own file because router.tsx exports a value, and a module that exports
// both a component and a value loses Fast Refresh.
// =============================================================================

import { Navigate, useParams } from 'react-router-dom';

export default function TripMapRedirect() {
  const { tripId } = useParams<{ tripId: string }>();
  return <Navigate to={tripId ? `/map?trip=${tripId}` : '/map'} replace />;
}
